import { render, staticRenderFns } from "./AlterarMensagemPronta.vue?vue&type=template&id=2c2a17d9"
import script from "./AlterarMensagemPronta.vue?vue&type=script&lang=ts"
export * from "./AlterarMensagemPronta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports